import React from 'react';

/** The bouncing chevron that tells you there is another point below. */
export default function ScrollHint({ targetId, label = 'Scroll down' }) {
  return (
    <button type="button" className="scroll-hint" onClick={() => document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' })} aria-label={label}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </button>
  );
}
